var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 8.0625V4.8125C2.8125 3.70793 3.70793 2.8125 4.8125 2.8125H13.1875C14.2921 2.8125 15.1875 3.70793 15.1875 4.8125V8.0625M2.8125 8.0625V13.1875C2.8125 14.2921 3.70793 15.1875 4.8125 15.1875H13.1875C14.2921 15.1875 15.1875 14.2921 15.1875 13.1875V8.0625M2.8125 8.0625H15.1875M8.0625 5.4375H12.9375M6.1875 5.4375C6.1875 5.74816 5.93566 6 5.625 6C5.31434 6 5.0625 5.74816 5.0625 5.4375C5.0625 5.12684 5.31434 4.875 5.625 4.875C5.93566 4.875 6.1875 5.12684 6.1875 5.4375Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.aac3f353aaa193819651fb3713e09f65.svg";
export { ForwardRef as ReactComponent };